export var REPLACEMENT_SUCCESS = 'success';
export var REPLACEMENT_ERROR = 'error';